<template>
    <div>

        <div v-if="Core.Session.isInitialized">
            <router-view></router-view>
        </div>

        <div v-if="!Core.Session.isInitialized" class="app flex-row align-items-center">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col md="12">
                        <div class="text-center">
                            <Request
                                    ref="session"
                                    method="GET"
                                    :options="{ blockOnProcessing: true, blockTransparent: true, blockImg: Core.Session.getValue('SessionBranchLogoLoading','environment.ui.logoLoading','environment.ui.appLogoLoading')}"
                                    :onRequestSuccess="requestSessionSuccess"
                                    :onRequestError="requestSessionError"
                                    root="/session">
                                <slot slot="body">
                                </slot>
                            </Request>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Request from './components/Request'
    export default {
        name: 'app',
        components: {
            Request
        },
        mounted() {
            if (!Core.Session.isInitialized) {
                Core.Session.retrieve()
                this.$refs.session.request()
                Core.Scan.initListener()
            }

            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/handsontable@12.4.0/dist/handsontable.full.min.js')
            document.head.appendChild(recaptchaScript)

            let link = document.createElement('link')
            link.setAttribute('href', 'https://cdn.jsdelivr.net/npm/handsontable@12.4.0/dist/handsontable.min.css')
            document.head.appendChild(link)

        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        methods: {
            requestSessionSuccess(data) {
                Core.Session.isInitialized = true
                if (data.environment !== undefined && data.environment.status !== undefined) {
                    if (Core.Environment.isSetup(data.environment.status)) {
                        this.$router.push(Core.Definition.getDefinition('/creation/environnement'))
                    }
                }
                if (data.session === undefined) {
                    Core.Session.reset()
                    Core.Session.AuthUser.reset()
                    Core.Session.setCookies()
                    Core.AuthUser.setCookies()
                    this.$router.push(Core.Definition.getDefinition('/connexion'))
                }

                if (Core.Session.environment.status !== undefined) {
                    switch(Core.Session.environment.status) {
                        case Core.Environment.statusMaintenance:
                            this.$router.push(Core.Definition.getDefinition('/maintenance'))
                            break
                    }
                }

                this.$forceUpdate()
            },
            requestSessionError() {
            }
        }
    }
</script>


<style lang="scss">
    // CoreUI Icons Set
    @import '~@coreui/icons/css/coreui-icons.min.css';
    /* Import Font Awesome Icons Set */
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/scss/font-awesome.scss';
    /* Import Simple Line Icons Set */

    /* Import Flag Icons Set */
    @import '~flag-icon-css/css/flag-icon.min.css';
    /* Import Bootstrap Vue Styles */
    @import '~bootstrap-vue/dist/bootstrap-vue.css';

    // Import Main styles for this application
    @import 'perfoplanning/assets/scss/style';
    //@import 'redbox/assets/scss/style';

    @import '../node_modules/handsontable/dist/handsontable.full.css';
</style>



